import React from "react"
export function AmendmentFill(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M10 2a8 8 0 110 16 8 8 0 010-16zm1.867 8.554l-.603.602.768.748-.038-.003c-.463-.043-.797-.148-1.009-.3l-.083-.069-.047-.049-.63.573.112.115c.317.292.766.474 1.342.557l.221.026-.636.619.603.602 1.45-1.41.042-.047a.418.418 0 00.015-.485l-.058-.07-1.45-1.41zm0-4.53l-.603.603.742.721-.49.003c-1.577.047-2.46.92-2.53 2.503l-.005.314c-.042 1.132-.72 1.695-2.191 1.75l-.206.004-.584.002.002.858.585-.002.155-.002c1.923-.054 3.005-.92 3.082-2.533l.006-.316c.035-1.137.55-1.672 1.66-1.718l.43-.005-.656.638.603.602 1.45-1.41.042-.047a.418.418 0 00.015-.485l-.058-.07-1.45-1.41zM6.592 7.482h-.591v.858h.591l.226.004c.58.021 1.005.126 1.274.298l.094.067.058.052.59-.616-.115-.102c-.393-.323-.96-.5-1.696-.547l-.252-.012-.179-.002z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  )
}
